import {faDoorOpen} from "@fortawesome/pro-solid-svg-icons/faDoorOpen";
import {faMegaphone} from "@fortawesome/pro-solid-svg-icons/faMegaphone";
import {faMoneyBillTransfer} from "@fortawesome/pro-solid-svg-icons/faMoneyBillTransfer";
import {faSignature} from "@fortawesome/pro-solid-svg-icons/faSignature";
import {ColourSolid} from "@twigsby/frontend-framework";
import {CommissionEarned} from "../../Pages/User/Referrals/CommissionEarned";
import {ReferralsSent} from "../../Pages/User/Referrals/ReferralsSent";
import {ReferralsSummary} from "../../Pages/User/Referrals/ReferralsSummary";
import {SignUps} from "../../Pages/User/Referrals/SignUps";
import {SuggestibleRouteInterface} from "../TopRoutes";

const ReferralRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Referrals Summary',
        path: '/manage-account/referrals/summary',
        icon: faDoorOpen,
        colour: ColourSolid.Secondary,
        element: <ReferralsSummary />,
        group: 'Referrals'
    },
    {
        title: 'Commission Earned',
        path: '/manage-account/referrals/commission-earned',
        icon: faMoneyBillTransfer,
        colour: ColourSolid.Secondary,
        element: <CommissionEarned />,
        group: 'Referrals'
    },
    {
        title: 'Referrals Sent',
        path: '/manage-account/referrals/sent',
        icon: faMegaphone,
        colour: ColourSolid.Secondary,
        element: <ReferralsSent />,
        group: 'Referrals'
    },
    {
        title: 'Sign-Ups',
        path: '/manage-account/referrals/sign-ups',
        icon: faSignature,
        colour: ColourSolid.Secondary,
        element: <SignUps />,
        group: 'Referrals'
    },
]

export { ReferralRoutes }
